import BaseError from "./BaseError";

export default class NotImplementedError extends BaseError {
  constructor(data) {
    super(data);
    this.name = "NotImplementedError";
  }
}
